// MainDashboard.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Hoot from "./Hoot";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { toast } from "react-toastify";

import {
  Modal,
  Button as MButton,
  TextField,
  Avatar,
  CircularProgress,
  Alert,
  Box,
  Tooltip,
} from "@mui/material";

import RefreshIcon from "@mui/icons-material/Refresh";
import PaidIcon from "@mui/icons-material/Paid";

import {
  FiMenu,
  FiSun,
  FiMoon,
  FiMessageSquare,
  FiCalendar,
  FiFileText,
  FiPlus,
  FiAlertTriangle,
  FiTool,
  FiFolder,
  FiClipboard,
  FiUser,
  FiBriefcase,
  FiBarChart2,
  FiX,
  FiImage,
  FiTrash2,
  FiEdit2,
  FiUpload,
  FiEye,
  FiMapPin,
  FiLink,
  FiGrid,
  FiList,
  FiChevronLeft,
  FiChevronRight,
  FiRss,
} from "react-icons/fi";

import { FaUsers, FaUserCheck, FaIdBadge, FaReceipt, FaBuilding } from "react-icons/fa";

import RegisterAndUpdateInstituteModal from "./RegisterAndUpdateInstituteModal";
import LicencesInstitutesTable from "./Components/LicencesInstitutesTables";
import LicencesPaymentsTable from "./Components/LicencesPaymentsTable";
import RegisterAndUpdateLicenceModal from "./Components/Modals/RegisterAndUpdateLicenceModal";
import RegisterSmsPaymentModal from "./Components/Modals/RegisterSmsPaymentModal";
import SmsPaymentsTable from "./Components/SmsSPaymentsTable";
import ContactsListTable from "./Components/ContactsListTable";
import MeetingsAgendaTable from "./Components/MeetingsAgendaTable";
import InactiveAccountsTable from "./Components/InactiveAccountsTable";
import InstitutesAnalytics from "./Components/Analytics/InstitutesAnalytics";
import TechniciansManager from "./Components/Technicians/TechniciansManager";
import FeedbacksManager from "./Components/Feedbacks/FeedbacksManager";
import DocumentsManager from "./Components/Documents/DocumentsManager";
import ComerciaisManager from "./Components/Comerciais/ComerciaisManager";
import ActivitiesManager from "./Components/Activities/ActivitiesManager";
import HRDashboard from "./Components/HR/HRDashboard";
import MyProfile from "./Components/Profile/MyProfile";
import ManagerAccounts from "./Components/ManagerAccounts/ManagerAccounts";
import getLogo from "./getLogo";
import TemplatesManager from "./Components/Templates/TemplatesManager";
import ContactsListMinimal from "./Components/ContactsListMinimal";
import SchoolProposalModal from "./Components/SchoolProposalModal";
// ── NEW ──────────────────────────────────────────────────────────────────────
import FeedNews from "./Components/FeedNews";
import ReferralsModalComponent from "./Components/Modals/ReferralsModalComponent";
import ContractModal from "./Components/ContractModal";
// ─────────────────────────────────────────────────────────────────────────────
import GoalStracker from "./GoalStracker";

axios.defaults.withCredentials = true;

/* =========================================================
   UI / THEME
========================================================= */
const dashboardStyles = `
:root{
  --primary:#6052ff;
  --bg:#f4f6fb;
  --card:#ffffff;
  --border:#e2e8f0;
  --text:#0f172a;
  --muted:#6b7280;
  --primary-soft:#ebe9ff;
  --primary-border:#d1ceff;
  --success:#16a34a;
  --warning:#f59e0b;
  --danger:#ef4444;
  --shadow: 0 14px 40px rgba(15,23,42,.08);
}

:root[data-theme="dark"]{
  --bg:#020617;
  --card:#0b1220;
  --border:#1f2937;
  --text:#e5e7eb;
  --muted:#9ca3af;
  --primary-soft:#232045;
  --primary-border:#4f46e5;
  --shadow: 0 18px 70px rgba(0,0,0,.35);
}

*{box-sizing:border-box;}
html,body{height:100%;}
body{
  font-family:"Montserrat",system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  background:var(--bg);
  color:var(--text);
}

/* Force inputs correct in dark */
:root[data-theme="dark"] .form-control,
:root[data-theme="dark"] .form-select,
:root[data-theme="dark"] textarea,
:root[data-theme="dark"] input[type="text"],
:root[data-theme="dark"] input[type="search"],
:root[data-theme="dark"] input[type="email"],
:root[data-theme="dark"] input[type="date"],
:root[data-theme="dark"] input[type="file"]{
  background:#0b1220 !important;
  color:var(--text) !important;
  border-color: var(--border) !important;
}
:root[data-theme="dark"] .form-control::placeholder,
:root[data-theme="dark"] input::placeholder,
:root[data-theme="dark"] textarea::placeholder{
  color: rgba(229,231,235,.65) !important;
}
:root[data-theme="dark"] .input-group-text{
  background:#0b1220 !important;
  color: var(--text) !important;
  border-color: var(--border) !important;
}

/* MUI dark fixes */
:root[data-theme="dark"] .MuiInputBase-root,
:root[data-theme="dark"] .MuiOutlinedInput-root{
  color: var(--text) !important;
}
:root[data-theme="dark"] .MuiOutlinedInput-notchedOutline{
  border-color: var(--border) !important;
}
:root[data-theme="dark"] .MuiFormLabel-root,
:root[data-theme="dark"] .MuiInputLabel-root{
  color: rgba(229,231,235,.75) !important;
}
:root[data-theme="dark"] .MuiPaper-root{
  background: var(--card) !important;
  color: var(--text) !important;
}

/* Layout */
.app-shell{ min-height:100vh; display:flex; flex-direction:column; }
.app-main-wrapper{ flex:1; display:flex; gap:0; padding-top:56px; }
.app-sidebar{
  width:270px;
  border-right:1px solid var(--border);
  background:var(--card);
  padding:12px 10px;
  display:none;
  position:sticky;
  top:56px;
  height:calc(100vh - 56px);
  overflow:auto;
}
@media (min-width:992px){ .app-sidebar{display:block;} }
.app-main{ flex:1; padding:14px 10px 20px; }

/* Navbar */
.navbar{
  background:var(--card) !important;
  border-bottom:1px solid var(--border) !important;
}
.brand-logo{ height:34px; width:auto; display:block; }
.brand-box{ display:flex; align-items:center; gap:10px; }
.brand-texts{ display:flex; flex-direction:column; line-height:1.05; }
.navbar-subtitle{ font-size:.74rem; color:var(--muted); font-weight:650; }

.nav-user-block{ display:flex; align-items:center; gap:8px; }
.nav-user-info{ display:flex; flex-direction:column; font-size:.78rem; }
.nav-user-name{ font-weight:800; }
.nav-user-email{ color:var(--muted); font-size:.72rem; }

/* Sidebar nav */
.app-nav-title{
  font-size:.72rem;
  text-transform:uppercase;
  letter-spacing:.08em;
  color:var(--muted);
  margin:10px 8px 6px;
  font-weight:900;
}
.app-nav-link{
  width:100%;
  border-radius:999px;
  border:1px solid transparent;
  font-size:.86rem;
  font-weight:800;
  padding:.52rem .82rem;
  background:transparent;
  color:var(--muted);
  display:flex;
  align-items:center;
  gap:.55rem;
  text-align:left;
  transition: background .14s ease, border-color .14s ease, color .14s ease;
}
.app-nav-link svg{ font-size:1.02rem; }
.app-nav-link:hover{
  background:rgba(148,163,184,0.12);
  border-color:rgba(148,163,184,0.30);
  color:var(--text);
}
.app-nav-link.active{
  background:var(--primary-soft);
  border-color:var(--primary-border);
  color:var(--primary);
}
.app-nav-link .nav-badge{
  margin-left:auto;
  font-size:.68rem;
  font-weight:950;
  padding:.18rem .55rem;
  border-radius:999px;
  border:1px solid rgba(148,163,184,0.35);
  background:rgba(148,163,184,0.10);
  color:var(--text);
}
:root[data-theme="dark"] .app-nav-link .nav-badge{
  border-color: rgba(31,41,55,0.9);
  background: rgba(2,6,23,0.45);
}

/* Buttons */
.btn-soft{
  border-radius:999px;
  border:1px solid rgba(148,163,184,0.35);
  background:var(--card);
  font-size:.85rem;
  font-weight:850;
  padding:10px;
  color:var(--text);
  display:inline-flex;
  align-items:center;
  gap:.4rem;
}
.btn-soft:hover{ background:rgba(148,163,184,0.10); }
.btn-icon{
  width:36px;height:36px;border-radius:14px;
  padding:0;border:1px solid rgba(148,163,184,0.35);
  background:var(--card);
  display:inline-grid;place-items:center;
  color:var(--muted);
}
.btn-icon:hover{ background:rgba(148,163,184,0.12); color:var(--text); }
.btn-logout{
  border-radius:999px;
  border:1px solid var(--danger);
  background:transparent;
  color:#b91c1c;
  font-size:.8rem;
  font-weight:850;
  padding:.28rem .78rem;
}

/* Cards */
.card-soft{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  padding:14px 16px;
  margin-bottom:14px;
  box-shadow: var(--shadow);
}
.card-soft-header{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:10px;
  margin-bottom:10px;
  flex-wrap:wrap;
}
.card-soft-title{ font-size:1.08rem; font-weight:950; }
.card-soft-subtitle{ font-size:.8rem; color:var(--muted); font-weight:650; }

/* Filter row: improved */
.filter-row{
  display:flex;
  gap:10px;
  align-items:center;
  flex-wrap:wrap;
  padding:10px 10px;
  border-radius:16px;
  background: linear-gradient(180deg, rgba(148,163,184,0.12), rgba(148,163,184,0.06));
  border:1px solid rgba(148,163,184,0.20);
  margin-bottom:10px;
}
:root[data-theme="dark"] .filter-row{
  background: linear-gradient(180deg, rgba(148,163,184,0.10), rgba(148,163,184,0.03));
  border-color: rgba(31,41,55,0.9);
}
.filter-search{ flex:1; min-width:260px; }
.filter-right{ display:flex; gap:10px; align-items:center; flex-wrap:wrap; }
.per-page{ display:flex; align-items:center; gap:8px; }
.per-page select{ max-width:92px; }

/* Tabs inside Clientes */
.clients-tabs{
  display:flex;
  gap:8px;
  flex-wrap:wrap;
  margin:8px 0 0;
}
.clients-tab{
  border-radius:999px;
  border:1px solid rgba(148,163,184,0.35);
  background:transparent;
  padding:8px 12px;
  font-weight:950;
  font-size:.82rem;
  color:var(--muted);
  display:inline-flex;
  align-items:center;
  gap:8px;
}
.clients-tab.active{
  background: var(--primary-soft);
  border-color: var(--primary-border);
  color: var(--primary);
}

/* Table (Institutes) */
.inst-table-wrapper{ width:100%; margin-top:10px; }
@media (max-width:768px){ .inst-table-desktop{display:none;} .inst-mobile-list{display:block;} }
@media (min-width:769px){ .inst-table-desktop{display:block;} .inst-mobile-list{display:none;} }

.inst-table{
  width:100%;
  border-collapse:separate;
  border-spacing:0;
  font-size:.84rem;
  color:var(--text);
  overflow:hidden;
}
.inst-table thead th{
  text-align:left;
  padding:.65rem .65rem;
  font-size:.78rem;
  font-weight:950;
  color:var(--muted);
  border-bottom:1px solid var(--border);
  background: linear-gradient(180deg, rgba(148,163,184,0.10), rgba(148,163,184,0.02));
}
.inst-table tbody td{
  padding:.65rem .65rem;
  border-bottom:1px solid rgba(148,163,184,0.28);
  vertical-align:middle;
}
.inst-table tbody tr:hover{ background:rgba(148,163,184,0.08); }

.inst-logo{
  width:46px;height:46px;border-radius:14px;overflow:hidden;
  background:rgba(148,163,184,0.22);
  display:flex;align-items:center;justify-content:center;
  font-size:.8rem;font-weight:900;color:#4b5563;
  border:1px solid rgba(148,163,184,0.30);
}
:root[data-theme="dark"] .inst-logo{ color:#e5e7eb; }
.inst-logo img{ width:100%; height:100%; object-fit:cover; }

/* Action icons (with tooltip vibes) */
.table-actions{ display:flex; gap:8px; justify-content:flex-end; flex-wrap:wrap; }
.action-icon{
  width:38px;height:38px;
  border-radius:14px;
  border:1px solid rgba(148,163,184,0.35);
  background:rgba(148,163,184,0.10);
  display:grid;
  place-items:center;
  cursor:pointer;
  color:var(--text);
  transition: transform .08s ease, background .12s ease, border-color .12s ease;
}
.action-icon:hover{ background:rgba(96,82,255,0.12); border-color: rgba(96,82,255,0.28); }
.action-icon:active{ transform: scale(.98); }

/* Mobile list */
.inst-mobile-list{ margin-top:4px; }
.minst-card{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  padding:12px;
  margin:10px 0;
  box-shadow: var(--shadow);
}
.minst-row{ display:flex; align-items:center; justify-content:space-between; gap:10px; }
.minst-line{ height:1px; background:var(--border); margin:10px 0; }
.minst-pill{
  display:inline-flex; align-items:center; gap:6px;
  border-radius:999px; background:rgba(148,163,184,0.14);
  padding:5px 10px; font-size:.76rem; font-weight:900;
  border:1px solid rgba(148,163,184,0.22);
}
.inst-footer{
  margin-top:12px;
  display:flex;
  justify-content:space-between;
  flex-wrap:wrap;
  gap:10px;
  align-items:center;
}

/* Badges */
.exp-badge{
  display:inline-flex;
  align-items:center;
  border-radius:999px;
  padding:2px 10px;
  font-size:.72rem;
  font-weight:950;
  border:1px solid rgba(148,163,184,0.25);
}
.exp-danger{ background:#fee2e2; color:#991b1b; border-color: rgba(239,68,68,.25); }
.exp-warning{ background:#fef3c7; color:#92400e; border-color: rgba(245,158,11,.25); }
.exp-info{ background:#dbeafe; color:#1d4ed8; border-color: rgba(59,130,246,.25); }
:root[data-theme="dark"] .exp-danger{ background: rgba(239,68,68,.14); color:#fecaca; }
:root[data-theme="dark"] .exp-warning{ background: rgba(245,158,11,.14); color:#fde68a; }
:root[data-theme="dark"] .exp-info{ background: rgba(59,130,246,.14); color:#bfdbfe; }

/* GRID: 4 items/row */
.grid-wrap{
  display:grid;
  grid-template-columns: repeat(4, 1fr);
  gap:12px;
  margin-top:12px;
}
@media(max-width:1200px){ .grid-wrap{ grid-template-columns: repeat(3, 1fr); } }
@media(max-width:980px){ .grid-wrap{ grid-template-columns: repeat(2, 1fr); } }
@media(max-width:620px){ .grid-wrap{ grid-template-columns: 1fr; } }

.gcard{
  border:1px solid var(--border);
  border-radius:20px;
  overflow:hidden;
  background:var(--card);
  box-shadow: var(--shadow);
  transition: transform .10s ease, box-shadow .15s ease;
}
.gcard:hover{ transform: translateY(-1px); }
.gcarousel{
  width:100%;
  max-width:400px;
  margin:0 auto;
  position:relative;
  background: rgba(148,163,184,0.10);
}
.gcarousel .carousel-inner{
  max-height:240px;
}
.gcarousel .carousel-item img{
  width:100%;
  height:240px;
  object-fit:cover;
  display:block;
}
.gcarousel .carousel-control-prev,
.gcarousel .carousel-control-next{
  opacity:0;
  transition: opacity .12s ease;
}
.gcard:hover .gcarousel .carousel-control-prev,
.gcard:hover .gcarousel .carousel-control-next{
  opacity:1;
}
.gcarousel .carousel-indicators{
  margin-bottom:10px;
  gap:6px;
}
.gcarousel .carousel-indicators [data-bs-target]{
  width:10px;height:10px;border-radius:999px;
  border:1px solid rgba(226,232,240,0.85);
}
.gbody{
  padding:12px 12px 14px;
  display:flex;
  flex-direction:column;
  gap:10px;
}
.gtitle{
  font-weight:950;
  font-size:.95rem;
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:10px;
}
.gdesc{
  color:var(--muted);
  font-size:.8rem;
  font-weight:650;
  line-height:1.35;
}
.gmeta{
  color:var(--muted);
  font-size:.78rem;
  display:flex;
  gap:10px;
  flex-wrap:wrap;
  align-items:center;
}
.gmeta span{ display:inline-flex; align-items:center; gap:6px; }
.gactions{
  display:flex;
  gap:8px;
  justify-content:space-between;
  flex-wrap:wrap;
  align-items:center;
}
.gaction-left{ display:flex; gap:8px; flex-wrap:wrap; }
.giconbtn{
  width:38px;height:38px;border-radius:14px;
  border:1px solid rgba(148,163,184,0.35);
  background: rgba(148,163,184,0.10);
  display:grid;
  place-items:center;
  cursor:pointer;
  color: var(--text);
}
.giconbtn:hover{ background: rgba(96,82,255,0.12); border-color: rgba(96,82,255,0.28); }

/* OFFCANVAS (Details) + backdrop */
.oc-backdrop{
  position:fixed;
  inset:0;
  background: rgba(2,6,23,0.55);
  z-index:1040;
  opacity:0;
  pointer-events:none;
  transition: opacity .18s ease;
}
.oc-backdrop.show{ opacity:1; pointer-events:auto; }

.oc-panel{
  position:fixed;
  top:0;
  right:0;
  height:100vh;
  width:min(620px, 96vw);
  background: var(--card);
  border-left:1px solid var(--border);
  z-index:1045;
  transform: translateX(105%);
  transition: transform .22s ease;
  display:flex;
  flex-direction:column;
  box-shadow: 0 30px 110px rgba(2,6,23,.45);
}
.oc-panel.show{ transform: translateX(0); }

.oc-hero{
  width:100%;
  min-height:400px;
  max-height:400px;
  border-bottom:1px solid var(--border);
  position:relative;
  background: rgba(148,163,184,0.10);
  overflow:hidden;
}
.oc-hero-slide{
  position:absolute;
  inset:0;
  opacity:0;
  transition: opacity .25s ease;
}
.oc-hero-slide.active{ opacity:1; }
.oc-hero-slide img{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
  cursor:zoom-in;
}
.oc-hero-overlay{
  position:absolute;
  inset:0;
  background: linear-gradient(180deg, rgba(2,6,23,0.10), rgba(2,6,23,0.62));
  pointer-events:none;
}
.oc-hero-topbar{
  position:absolute;
  top:12px;
  left:12px;
  right:12px;
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  z-index:4;
}
.oc-hero-badge{
  background: rgba(255,255,255,0.92);
  border:1px solid rgba(226,232,240,0.85);
  color:#0f172a;
  font-weight:950;
  font-size:.82rem;
  padding:7px 12px;
  border-radius:999px;
  max-width: 78%;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}
:root[data-theme="dark"] .oc-hero-badge{
  background: rgba(2,6,23,0.60);
  border-color: rgba(31,41,55,0.85);
  color: #e5e7eb;
}
.oc-hero-nav{ display:flex; gap:10px; z-index:4; }
.oc-hero-btn{
  width:42px;height:42px;
  border-radius:14px;
  border:1px solid rgba(226,232,240,0.75);
  background: rgba(255,255,255,0.88);
  display:grid;
  place-items:center;
  cursor:pointer;
  font-size:18px;
  transition: transform .08s ease, background .12s ease;
}
.oc-hero-btn:hover{ background: rgba(255,255,255,0.98); }
.oc-hero-btn:active{ transform: scale(.98); }
:root[data-theme="dark"] .oc-hero-btn{
  background: rgba(2,6,23,0.55);
  border-color: rgba(31,41,55,0.85);
  color: var(--text);
}
.oc-hero-dots{
  position:absolute;
  left:50%;
  transform:translateX(-50%);
  bottom:14px;
  display:flex;
  gap:10px;
  z-index:4;
  max-width: 400px;
  padding: 8px 10px;
  border-radius: 999px;
  background: rgba(2,6,23,0.18);
  backdrop-filter: blur(6px);
}
.oc-dot{
  width:10px;height:10px;border-radius:999px;
  border:1px solid rgba(226,232,240,0.85);
  background: rgba(255,255,255,0.45);
  cursor:pointer;
}
.oc-dot.active{
  background: rgba(96,82,255,0.95);
  border-color: rgba(96,82,255,0.95);
}
.oc-hero-empty{
  min-height:400px;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-direction:column;
  gap:10px;
  padding:18px;
}
.oc-hero-empty h6{ margin:0; font-weight:950; }
.oc-hero-empty p{ margin:0; color: var(--muted); font-size:.85rem; text-align:center; }

/* Offcanvas body */
.oc-body{
  padding:14px 14px 18px;
  overflow:auto;
  flex:1;
}
.oc-headline{
  display:flex;
  justify-content:space-between;
  gap:10px;
  align-items:flex-start;
  flex-wrap:wrap;
  margin-bottom:10px;
}
.oc-title{ font-weight:950; font-size:1.08rem; margin:0; }
.oc-sub{
  margin-top:6px;
  color:var(--muted);
  font-size:.82rem;
  display:flex;
  gap:8px;
  align-items:center;
  flex-wrap:wrap;
}
.oc-chip{
  display:inline-flex;
  align-items:center;
  gap:8px;
  background: rgba(148,163,184,0.14);
  border:1px solid rgba(15,23,42,.08);
  border-radius:999px;
  padding:6px 10px;
  font-size:.78rem;
  font-weight:950;
}
.oc-tabs{
  display:flex;
  gap:8px;
  flex-wrap:wrap;
  margin-top:12px;
  margin-bottom:10px;
}
.oc-tab{
  border-radius:999px;
  border:1px solid rgba(148,163,184,0.30);
  background:transparent;
  padding:8px 12px;
  font-weight:950;
  font-size:.82rem;
  color:var(--muted);
}
.oc-tab.active{
  background: var(--primary-soft);
  border-color: var(--primary-border);
  color: var(--primary);
}
.oc-block{
  border:1px solid var(--border);
  border-radius:18px;
  padding:12px;
  background: rgba(148,163,184,0.05);
}
.oc-grid{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:10px;
}
@media(max-width:560px){ .oc-grid{grid-template-columns:1fr;} }

.oc-label{
  font-size:.78rem;
  color:var(--muted);
  font-weight:950;
  margin-bottom:6px;
}
.oc-input{
  width:100%;
  border:1px solid rgba(148,163,184,0.30);
  border-radius:14px;
  padding:10px 12px;
  background:var(--card);
  color:var(--text);
  font-weight:750;
}
.img-grid{
  display:grid;
  grid-template-columns: repeat(2, 1fr);
  gap:10px;
}
@media(max-width:420px){ .img-grid{grid-template-columns: 1fr;} }
.img-item{
  border-radius:18px;
  border:1px solid var(--border);
  overflow:hidden;
  background: rgba(148,163,184,0.06);
}
.img-item img{
  width:100%;
  height:190px;
  object-fit:cover;
  display:block;
  cursor:zoom-in;
}
.img-actions{
  display:flex;
  gap:8px;
  padding:10px;
  justify-content:flex-end;
}

/* Sections */
.app-section{ display:none; }
.app-section.active{ display:block; }

.small-muted{ font-size:.76rem; color:var(--muted); font-weight:650; }
`;

/* =========================================================
   Icons
========================================================= */
const NavIcon = ({ id }) => {
  switch (id) {
    case "clients":
      return <FaBuilding />;
    case "licences":
      return <FaIdBadge />;
    case "licencespayments":
      return <FaReceipt />;
    case "sms":
      return <FiMessageSquare />;
    case "contacts":
      return <FaUsers />;
    case "agenda":
      return <FiCalendar />;
    case "users":
      return <FiUser />;
    case "accounts":
      return <FaUserCheck />;
    case "technicians":
      return <FiTool />;
    case "feedbacks":
      return <FiClipboard />;
    case "documents":
      return <FiFolder />;
    case "comerciais":
      return <FiBriefcase />;
    case "activities":
      return <FiBarChart2 />;
    case "hr":
      return <FiFileText />;
    // ── NEW ────────────────────────────────────────────────
    case "feednews":
      return <FiRss />;
    // ───────────────────────────────────────────────────────
    case "profile":
      return <FiUser />;
    default:
      return <FiMenu />;
  }
};

/* =========================================================
   Helpers
========================================================= */
const clampName = (name, max = 40) => {
  const s = String(name || "");
  if (s.length <= max) return s;
  return s.slice(0, max - 1) + "…";
};

const safeValue = (v, fb = "—") => (v === null || v === undefined || v === "" ? fb : v);

const normalizeStr = (str) =>
  str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : "";

/* =========================================================
   Main
========================================================= */
function MainDashboard() {
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);

  // theme
  const [theme, setTheme] = useState("light");

  // Clients content
  const [institutes, setInstitutes] = useState([]);
  const [filteredInstitutes, setFilteredInstitutes] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [loading, setLoading] = useState(false);

  // navigation — persists across refresh via localStorage; resets on logout
  const [activeSection, setActiveSection] = useState(
    () => localStorage.getItem("educrm-active-section") || "contacts"
  );
  const [clientsTab, setClientsTab] = useState("institutes"); // institutes | institutes_grid | institutes_analytics

  // Details offcanvas
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsInstitute, setDetailsInstitute] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [detailsTab, setDetailsTab] = useState("fields");
  const [detailsData, setDetailsData] = useState({ fields: [], map_iframe: "", images: [] });

  const [newFieldKey, setNewFieldKey] = useState("");
  const [newFieldValue, setNewFieldValue] = useState("");
  const [mapIframe, setMapIframe] = useState("");
  const [uploadImages, setUploadImages] = useState([]);

  // slider + lightbox
  const [sliderIndex, setSliderIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxUrl, setLightboxUrl] = useState("");

  // Grid carousel images cache (by institute_code)
  const [gridImagesCache, setGridImagesCache] = useState({}); // { [code]: images[] }

  const LOGO_LIGHT =
    "https://ik.imagekit.io/zks5iegia/image-gen__1_-removebg-preview.png?updatedAt=1767179901347";
  const LOGO_DARK = "https://ik.imagekit.io/zks5iegia/image-gen__2___1_-removebg-preview.png";

  // Persist active section to localStorage on every change
  useEffect(() => {
    localStorage.setItem("educrm-active-section", activeSection);
        const saved = localStorage.getItem("educrm-theme") || "light";
    setTheme(saved);
    document.documentElement.setAttribute("data-theme", saved);
  }, [activeSection]);


  

  const toggleTheme = () => {
    const next = theme === "light" ? "dark" : "light";
    setTheme(next);
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem("educrm-theme", next);
  };

  // Fetch initial
  useEffect(() => {
    fetchUserData();
    fetchInstitutes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUserData = async () => {
    try {
      const res = await axios.get(Hoot() + "me", { withCredentials: true });
      setUserData(res.data);
    } catch {
      setError("Erro ao buscar dados do utilizador.");
    }
  };

  const fetchInstitutes = async () => {
    try {
      setLoading(true);
      const res = await axios.get(Hoot() + "institutes", { withCredentials: true });
      const list = res.data || [];
      setInstitutes(list);
      setFilteredInstitutes(list);
    } catch {
      setError("Erro ao buscar instituições.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const query = (e.target.value || "").toLowerCase();
    setSearchQuery(query);

    const filteredData = (institutes || []).filter((institute) =>
      (institute.name || "").toLowerCase().includes(query) ||
      (institute.email || "").toLowerCase().includes(query) ||
      (institute.phone && institute.phone.toString().includes(query)) ||
      (institute.nif || "").toLowerCase().includes(query) ||
      (institute.state || "").toLowerCase().includes(query)
    );

    setFilteredInstitutes(filteredData);
    setPage(0);
  };

  const handleRefresh = () => fetchInstitutes();

  const handleLogout = async () => {
    try {
      await axios.post(Hoot() + "logout", {}, { withCredentials: true });
      localStorage.removeItem("educrm-active-section");
      navigate("/login");
    } catch {
      setError("Erro ao terminar sessão.");
    }
  };

  const handleDeleteInstitute = async () => {
    try {
      if (selectedInstitute !== null) {
        await axios.delete(Hoot() + `institutes/${selectedInstitute}`, { withCredentials: true });
        setInstitutes((prev) => prev.filter((institute) => institute.id !== selectedInstitute));
        setFilteredInstitutes((prev) => prev.filter((institute) => institute.id !== selectedInstitute));
        setShowDeleteModal(false);
        toast.success("Instituição removida.");
      }
    } catch {
      setError("Erro ao excluir a instituição.");
    }
  };

  const getExpiryBadgeClass = (remainingDays) => {
    if (remainingDays < 30) return "exp-badge exp-danger";
    if (remainingDays < 70) return "exp-badge exp-warning";
    return "exp-badge exp-info";
  };

  const getRoleClassName = (role) => {
    switch (role) {
      case "normal":
        return "form-select role-select role-normal";
      case "ensinobasico":
        return "form-select role-select role-ensinobasico";
      case "ensinomedio":
        return "form-select role-select role-ensinomedio";
      default:
        return "form-select role-select role-normal";
    }
  };

  const handleRoleChange = async (code, newRole) => {
    try {
      await axios.put(Hoot() + `institutes/${code}/role`, { role: newRole }, { withCredentials: true });
      setInstitutes((prev) => prev.map((inst) => (inst.code === code ? { ...inst, role: newRole } : inst)));
      setFilteredInstitutes((prev) => prev.map((inst) => (inst.code === code ? { ...inst, role: newRole } : inst)));
      toast.success("Função da escola atualizada com sucesso!");
    } catch {
      toast.error("Erro ao atualizar função da escola.");
    }
  };

  /* =========================
     Access control (from /me)
     - backend returns: { access: { all, menu_ids } }
     - clients group tabs are: institutes / institutes_grid / institutes_analytics
     - sidebar now has only "clients"
     - "feednews" and "profile" are always visible (no access check)
  ========================= */
  const access = userData?.access || { all: false, menu_ids: [] };
  const canSee = (menuId) => {
    if (access?.all) return true;
    const ids = access?.menu_ids || [];

    // sidebar "clients" depends on any of the 3 old ids
    if (menuId === "clients") {
      return ids.includes("clients") || ids.includes("institutes") || ids.includes("institutes_grid") || ids.includes("institutes_analytics");
    }

    return ids.includes(menuId);
  };

  const canSeeClientsTab = (tabId) => {
    if (access?.all) return true;
    const ids = access?.menu_ids || [];
    // accept old ids directly
    return ids.includes(tabId) || ids.includes("clients");
  };

  const navItems = useMemo(() => {
    const base = [
      { id: "clients", label: "Clientes" },
      { id: "licences", label: "Licenças" },
      { id: "licencespayments", label: "Pag. Licenças" },
      { id: "sms", label: "Pag. SMS" },
      { id: "contacts", label: "Contactos" },
      { id: "agenda", label: "Agenda & eventos" },
      { id: "users", label: "Contas de utilizadores" },
      { id: "accounts", label: "Activar contas" },
      { id: "technicians", label: "Técnicos" },
      { id: "feedbacks", label: "Feedbacks" },
      { id: "documents", label: "Documentos" },
      { id: "comerciais", label: "Comerciais" },
      { id: "activities", label: "Actividades internas" },
      { id: "hr", label: "RH / Contabilidade" },
      { id: "templates", label: "Templates de documentos" },
    ];

    // Filter by access (if not master/all)
    const filtered = base.filter((it) => canSee(it.id));

    // ── Always-visible items (no access gate) ──────────────── 
    filtered.push({ id: "profile", label: "Meu perfil" });
    // ─────────────────────────────────────────────────────────

    return filtered;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.access?.all, JSON.stringify(userData?.access?.menu_ids || [])]);

  // If active section becomes forbidden after access data loads, fallback to feednews
  useEffect(() => {
    if (!navItems.length) return;
    const exists = navItems.some((x) => x.id === activeSection); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navItems.length]);

  // Ensure clientsTab allowed
  useEffect(() => {
    const allowedTabs = ["institutes", "institutes_grid", "institutes_analytics"].filter(canSeeClientsTab);
    if (!allowedTabs.length) return;
    if (!allowedTabs.includes(clientsTab)) setClientsTab(allowedTabs[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.access?.all, JSON.stringify(userData?.access?.menu_ids || [])]);

  /* =========================
     Details (Offcanvas)
  ========================= */
  const openLightbox = (url) => {
    if (!url) return;
    setLightboxUrl(url);
    setLightboxOpen(true);
  };

  const refreshDetails = async () => {
    if (!detailsInstitute?.code) return;
    try {
      const res = await axios.get(Hoot() + `institutes/${detailsInstitute.code}/details`, { withCredentials: true });
      const payload = res.data || {};
      setDetailsData({
        fields: payload.fields || [],
        map_iframe: payload.map_iframe || "",
        images: payload.images || [],
      });
      setMapIframe(payload.map_iframe || "");
    } catch {
      // silent
    }
  };

  const openDetails = async (inst) => {
    try {
      setDetailsInstitute(inst);
      setDetailsOpen(true);
      setDetailsTab("fields");
      setSliderIndex(0);
      setDetailsLoading(true);
      setError(null);

      const res = await axios.get(Hoot() + `institutes/${inst.code}/details`, { withCredentials: true });
      const payload = res.data || {};

      setDetailsData({
        fields: payload.fields || [],
        map_iframe: payload.map_iframe || "",
        images: payload.images || [],
      });
      setMapIframe(payload.map_iframe || "");
    } catch {
      toast.error("Erro ao carregar detalhes da instituição.");
    } finally {
      setDetailsLoading(false);
    }
  };

  const closeDetails = () => {
    setDetailsOpen(false);
    setDetailsInstitute(null);
    setDetailsTab("fields");
    setDetailsData({ fields: [], map_iframe: "", images: [] });
    setNewFieldKey("");
    setNewFieldValue("");
    setMapIframe("");
    setUploadImages([]);
    setSliderIndex(0);
  };

  const addField = async () => {
    try {
      if (!detailsInstitute?.code) return;
      if (!newFieldKey.trim()) {
        toast.warning("Informe o nome do campo.");
        return;
      }
      await axios.post(
        Hoot() + `institutes/${detailsInstitute.code}/details/fields`,
        { key: newFieldKey.trim(), value: newFieldValue },
        { withCredentials: true }
      );
      setNewFieldKey("");
      setNewFieldValue("");
      await refreshDetails();
      toast.success("Campo adicionado!");
    } catch {
      toast.error("Erro ao adicionar campo.");
    }
  };

  const deleteField = async (id) => {
    try {
      if (!detailsInstitute?.code) return;
      await axios.delete(Hoot() + `institutes/${detailsInstitute.code}/details/fields/${id}`, {
        withCredentials: true,
      });
      await refreshDetails();
      toast.success("Campo removido!");
    } catch {
      toast.error("Erro ao remover campo.");
    }
  };

  const saveMap = async () => {
    try {
      if (!detailsInstitute?.code) return;
      await axios.put(
        Hoot() + `institutes/${detailsInstitute.code}/details/map`,
        { map_iframe: mapIframe || "" },
        { withCredentials: true }
      );
      await refreshDetails();
      toast.success("Mapa atualizado!");
    } catch {
      toast.error("Erro ao atualizar mapa.");
    }
  };

  const uploadExtraImages = async () => {
    try {
      if (!detailsInstitute?.code) return;
      if (!uploadImages.length) {
        toast.warning("Selecione pelo menos 1 imagem.");
        return;
      }

      const fd = new FormData();
      uploadImages.forEach((f) => fd.append("images", f));

      await axios.post(Hoot() + `institutes/${detailsInstitute.code}/details/images/upload`, fd, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });

      setUploadImages([]);
      await refreshDetails();
      toast.success("Imagens enviadas!");
    } catch {
      toast.error("Erro ao enviar imagens.");
    }
  };

  const deleteImage = async (id) => {
    try {
      if (!detailsInstitute?.code) return;
      await axios.delete(Hoot() + `institutes/${detailsInstitute.code}/details/images/${id}`, {
        withCredentials: true,
      });
      await refreshDetails();
      toast.success("Imagem removida!");
    } catch {
      toast.error("Erro ao remover imagem.");
    }
  };

  const heroImages = detailsData?.images || [];
  const hasHero = heroImages.length > 0;

  useEffect(() => {
    const n = (detailsData?.images || []).length;
    if (!n) {
      setSliderIndex(0);
      return;
    }
    if (sliderIndex > n - 1) setSliderIndex(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailsData?.images?.length]);

  const goPrev = () => {
    if (!hasHero) return;
    setSliderIndex((p) => (p - 1 + heroImages.length) % heroImages.length);
  };
  const goNext = () => {
    if (!hasHero) return;
    setSliderIndex((p) => (p + 1) % heroImages.length);
  };

  /* =========================
     Stats / pagination
  ========================= */
  const totalInstitutes = filteredInstitutes.length;
  const totalSms = filteredInstitutes.reduce((acc, inst) => acc + (inst.totalsms || 0), 0);
  const expiringSoon = filteredInstitutes.filter((inst) => inst.licence && (inst.licence.remaining_days || 0) < 30)
    .length;

  const pageCount = Math.ceil(filteredInstitutes.length / rowsPerPage) || 1;
  const visibleInstitutes = filteredInstitutes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const renderPageNumbers = () => {
    const buttons = [];
    const currentPage = page + 1;
    const maxButtons = 7;

    if (pageCount <= maxButtons) {
      for (let i = 1; i <= pageCount; i++) buttons.push(i);
    } else {
      buttons.push(1);
      let start = Math.max(2, currentPage - 1);
      let end = Math.min(pageCount - 1, currentPage + 1);
      if (start > 2) buttons.push("...");
      for (let i = start; i <= end; i++) buttons.push(i);
      if (end < pageCount - 1) buttons.push("...");
      buttons.push(pageCount);
    }

    return buttons.map((p, idx) =>
      p === "..." ? (
        <li key={`ellipsis-${idx}`} className="page-item disabled">
          <span className="page-link">…</span>
        </li>
      ) : (
        <li key={p} className={`page-item ${currentPage === p ? "active" : ""}`}>
          <button className="page-link" onClick={() => setPage(p - 1)}>
            {p}
          </button>
        </li>
      )
    );
  };

  /* =========================
     Grid: prefetch images for visible items (per page)
  ========================= */
  useEffect(() => {
    const pageItems = visibleInstitutes || [];
    const codesToFetch = pageItems
      .map((x) => x.code)
      .filter(Boolean)
      .filter((code) => gridImagesCache[code] === undefined);

    if (!codesToFetch.length) return;

    let alive = true;

    (async () => {
      try {
        const batches = codesToFetch.slice(0, 12);
        const results = await Promise.all(
          batches.map(async (code) => {
            try {
              const r = await axios.get(Hoot() + `institutes/${code}/details/images`, { withCredentials: true });
              return { code, images: r.data || [] };
            } catch {
              return { code, images: [] };
            }
          })
        );

        if (!alive) return;

        setGridImagesCache((prev) => {
          const next = { ...prev };
          for (const it of results) next[it.code] = it.images;
          return next;
        });
      } catch {
        // silent
      }
    })();

    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, searchQuery, clientsTab]);

  /* =========================
     UI
  ========================= */
  const brandLogo = theme === "dark" ? LOGO_DARK : LOGO_LIGHT;

  const mobileMenuId = "offcanvasMenu";

  const clientsTabs = useMemo(() => {
    const list = [
      { id: "institutes", label: "Tabela", icon: <FiList /> },
      { id: "institutes_grid", label: "Galeria", icon: <FiGrid /> },
      { id: "institutes_analytics", label: "Analytics", icon: <FiBarChart2 /> },
    ];
    return list.filter((t) => canSeeClientsTab(t.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.access?.all, JSON.stringify(userData?.access?.menu_ids || [])]);

  // Keep clientsTab in sync if tabs shrink
  useEffect(() => {
    if (!clientsTabs.length) return;
    if (!clientsTabs.some((t) => t.id === clientsTab)) setClientsTab(clientsTabs[0].id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientsTabs.length]);

  const instituteCardDesc = (inst) => {
    const parts = [];
    if (inst?.state) parts.push(inst.state);
    if (inst?.phone) parts.push(`Tel: ${inst.phone}`);
    if (inst?.email) parts.push(inst.email);
    const s = parts.join(" • ");
    return s || "Sem informações adicionais.";
  };

  const picture = userData?.eduall_user_session_picture ?? "";

  const cleanPicture = picture.replace(
    /(\.(jpg|jpeg|png|webp|gif)).*$/i,
    "$1"
  );


  return (
    <>
      <style>{dashboardStyles}</style>
      <GoalStracker />
      <div className="app-shell">
        {/* TOP NAV */}
        <nav className="navbar navbar-expand fixed-top">
          <div className="container-fluid">
            <div className="brand-box">
              <img className="brand-logo" src={brandLogo} alt="Eduall Comercial" />
              <div className="brand-texts">
               {userData?.charge?.toLowerCase() !== "parceiros" ?  <div className="navbar-subtitle">Clientes • Licenças • SMS • Contactos</div> :  <div className="navbar-subtitle">Parceiros</div>}
              </div>
            </div>

            <div className="d-flex align-items-center gap-2">
              <ContractModal />
               <SchoolProposalModal />
               <ReferralsModalComponent />
              <Tooltip title="Alternar modo claro/escuro" arrow>
                <button className="btn-icon" type="button" onClick={toggleTheme}>
                  {theme === "dark" ? <FiSun /> : <FiMoon />}
                </button>
              </Tooltip>

              <div className="nav-user-block d-none d-sm-flex">
                {userData ? (
                  <>
                    <Avatar
                      src={cleanPicture}
                      sx={{ width: 34, height: 34 }}
                    />
                    <div className="nav-user-info">
                      <span className="nav-user-name">
                        {userData.name || userData.eduall_user_session_name || "—"}
                      </span>
                      <span className="nav-user-email">
                        {userData.email || userData.eduall_user_session_email || "—"}
                      </span>
                    </div>
                  </>
                ) : null}

                <button className="btn-logout ms-2" onClick={handleLogout}>
                  Terminar sessão
                </button>
              </div>

              {/* OFFCANVAS MENU BTN */}
              <Tooltip title="Menu" arrow>
                <button
                  className="btn-icon d-lg-none"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target={`#${mobileMenuId}`}
                  aria-controls={mobileMenuId}
                >
                  <FiMenu />
                </button>
              </Tooltip>
            </div>
          </div>
        </nav>

        {/* MOBILE MENU OFFCANVAS (LEFT) */}
        <div className="offcanvas offcanvas-start" tabIndex="-1" id={mobileMenuId} aria-labelledby="offcanvasMenuLabel">
          <div className="offcanvas-header">
            <h5
              className="offcanvas-title"
              id="offcanvasMenuLabel"
              style={{ display: "flex", gap: 10, alignItems: "center" }}
            >
              <img className="brand-logo" src={brandLogo} alt="Eduall Comercial" />
              <span>Eduall Comercial</span>
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Fechar"></button>
          </div>
          <div className="offcanvas-body">
            <div className="app-nav-title">Menu</div>

            {!navItems.length ? (
              <div className="small-muted">Sem acessos atribuídos.</div>
            ) : (
              navItems.map((item) => (
                <button
                  key={item.id}
                  className={"app-nav-link" + (activeSection === item.id ? " active" : "")}
                  data-bs-dismiss="offcanvas"
                  onClick={() => setActiveSection(item.id)}
                >
                  <NavIcon id={item.id} />
                  {item.label}
                </button>
              ))
            )}
          </div>
        </div>

        {/* MAIN LAYOUT */}
        <div className="app-main-wrapper">
          {/* DESKTOP SIDEBAR */}
          <aside className="app-sidebar d-none d-lg-block">
            <div className="app-nav-title">Principal</div>

            {!navItems.length ? (
              <div className="small-muted px-2">Sem acessos atribuídos.</div>
            ) : (
              navItems.map((item) => (
                <Tooltip key={item.id} title={item.label} placement="right" arrow>
                  <button
                    className={"app-nav-link" + (activeSection === item.id ? " active" : "")}
                    onClick={() => setActiveSection(item.id)}
                  >
                    <NavIcon id={item.id} />
                    {item.label}
                  </button>
                </Tooltip>
              ))
            )}

            <div className="mt-auto small-muted pt-3 px-2">
              Eduall portal <span className="nav-badge">{access?.all ? "MASTER" : "ACESSO"}</span>
            </div>
          </aside>

          <main className="app-main container-fluid">
            {userData?.charge?.toLowerCase() === "parceiros" ?

                <section className={"app-section" + (activeSection === "contacts" ? " active" : "")}>
                  <div className="card-soft">
                    <div className="card-soft-header">
                      <div>
                        <div className="card-soft-title">Contactos</div>
                        <div className="card-soft-subtitle">Lista de contactos / escolas potenciais.</div>
                      </div>
                    </div>
                     <ContactsListMinimal />
                    </div>
                </section>

                :
               <aside>

                {/* ======================
                    OTHER SECTIONS
                  ====================== */}
                <section className={"app-section" + (activeSection === "licences" ? " active" : "")}>
                  <div className="card-soft">
                    <div className="card-soft-header">
                      <div>
                        <div className="card-soft-title">Licenças</div>
                        <div className="card-soft-subtitle">Gestão das licenças por instituição.</div>
                      </div>
                    </div>
                    <LicencesInstitutesTable />
                  </div>
                </section>

                <section className={"app-section" + (activeSection === "licencespayments" ? " active" : "")}>
                  <div className="card-soft">
                    <div className="card-soft-header">
                      <div>
                        <div className="card-soft-title">Histórico de Pagamentos de Licenças</div>
                        <div className="card-soft-subtitle">Lista de todos os pagamentos efectuados.</div>
                      </div>
                    </div>
                    <LicencesPaymentsTable />
                  </div>
                </section>

                <section className={"app-section" + (activeSection === "sms" ? " active" : "")}>
                  <div className="card-soft">
                    <div className="card-soft-header">
                      <div>
                        <div className="card-soft-title">Pagamentos de SMS</div>
                        <div className="card-soft-subtitle">Todos os movimentos de créditos de SMS.</div>
                      </div>
                    </div>
                    <SmsPaymentsTable />
                  </div>
                </section>

                <section className={"app-section" + (activeSection === "contacts" ? " active" : "")}>
                  <div className="card-soft">
                    <div className="card-soft-header">
                      <div>
                        <div className="card-soft-title">Contactos</div>
                        <div className="card-soft-subtitle">Lista de contactos / escolas potenciais.</div>
                      </div>
                    </div>
                    <ContactsListTable />
                  </div>
                </section>

                <section className={"app-section" + (activeSection === "agenda" ? " active" : "")}>
                  <div className="card-soft">
                    <div className="card-soft-header">
                      <div>
                        <div className="card-soft-title">Agenda & eventos</div>
                        <div className="card-soft-subtitle">Reuniões, demonstrações e eventos planeados.</div>
                      </div>
                    </div>
                    <MeetingsAgendaTable />
                  </div>
                </section>

                <section className={"app-section" + (activeSection === "users" ? " active" : "")}>
                  <div className="card-soft">
                    <div className="card-soft-header">
                      <div>
                        <div className="card-soft-title">Contas de utilizadores</div>
                        <div className="card-soft-subtitle">Gestão de contas de managers e permissões.</div>
                      </div>
                    </div>
                    <ManagerAccounts />
                  </div>
                </section>

                <section className={"app-section" + (activeSection === "accounts" ? " active" : "")}>
                  <div className="card-soft">
                    <div className="card-soft-header">
                      <div>
                        <div className="card-soft-title">Activar contas</div>
                        <div className="card-soft-subtitle">Contas de escolas à espera de activação.</div>
                      </div>
                    </div>
                    <InactiveAccountsTable />
                  </div>
                </section>

                <section className={"app-section" + (activeSection === "technicians" ? " active" : "")}>
                  <TechniciansManager />
                </section>

                <section className={"app-section" + (activeSection === "feedbacks" ? " active" : "")}>
                  <FeedbacksManager />
                </section>

                

                <section className={"app-section" + (activeSection === "documents" ? " active" : "")}>
                  <DocumentsManager />
                </section>

                <section className={"app-section" + (activeSection === "comerciais" ? " active" : "")}>
                  <ComerciaisManager />
                </section>

                <section className={"app-section" + (activeSection === "activities" ? " active" : "")}>
                  <ActivitiesManager />
                </section>

                <section className={"app-section" + (activeSection === "hr" ? " active" : "")}>
                  <HRDashboard />
                </section>

                <section className={"app-section" + (activeSection === "templates" ? " active" : "")}>
                  <TemplatesManager />
                </section>
  
                <section className={"app-section" + (activeSection === "profile" ? " active" : "")}>
                  <MyProfile />
                </section>

                </aside>

            }
            {/* ======================
                SECTION: CLIENTES (tabs)
               ====================== */}
            <section className={"app-section" + (activeSection === "clients" ? " active" : "")}>
              <div className="card-soft">
                <div className="card-soft-header">
                  <div>
                    <div className="card-soft-title">Clientes</div>
                    <div className="card-soft-subtitle">
                      Instituições, galeria e analytics — tudo no mesmo menu.
                    </div>
                    <div className="clients-tabs">
                      {clientsTabs.map((t) => (
                        <button
                          key={t.id}
                          className={"clients-tab" + (clientsTab === t.id ? " active" : "")}
                          type="button"
                          onClick={() => setClientsTab(t.id)}
                        >
                          {t.icon}
                          {t.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    {/* create institute */}
                    <RegisterAndUpdateInstituteModal
                      toggle_btn={
                        <Tooltip title="Adicionar nova instituição" arrow>
                          <button className="btn-soft" type="button">
                            <FiPlus />
                            Adicionar
                          </button>
                        </Tooltip>
                      }
                    />
                  </div>
                </div>

                {/* small stats */}
                <div className="d-flex flex-wrap gap-2 mb-2">
                  <span className="minst-pill">
                    <FaBuilding /> {totalInstitutes} instituição(ões)
                  </span>
                  <span className="minst-pill">
                    <FiMessageSquare /> {totalSms} SMS
                  </span>
                  <span className="minst-pill">
                    <FiAlertTriangle /> {expiringSoon} a expirar (&lt;30 dias)
                  </span>
                </div>

                {error ? (
                  <div className="mb-2">
                    <Alert severity="error">{error}</Alert>
                  </div>
                ) : null}

                {/* FILTER ROW */}
                <div className="filter-row">
                  <div className="filter-search">
                    <TextField
                      label="Pesquisar clientes (nome, email, telefone, NIF, província...)"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>

                  <div className="filter-right">
                    <Tooltip title="Atualizar lista" arrow>
                      <span>
                        <MButton
                          variant="outlined"
                          className="btn-soft"
                          onClick={handleRefresh}
                          disabled={loading}
                          startIcon={loading ? <CircularProgress size={16} /> : <RefreshIcon />}
                        >
                        </MButton>
                      </span>
                    </Tooltip>

                    <div className="per-page">
                      <span className="small-muted">Por página:</span>
                      <select
                        className="form-select form-select-sm"
                        value={rowsPerPage}
                        onChange={(e) => {
                          setRowsPerPage(parseInt(e.target.value, 10));
                          setPage(0);
                        }}
                      >
                        <option value={8}>8</option>
                        <option value={12}>12</option>
                        <option value={16}>16</option>
                        <option value={20}>20</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* ===== TAB: TABELA ===== */}
                {clientsTab === "institutes" ? (
                  <div className="inst-table-wrapper">
                    <div className="inst-table-desktop">
                      <table className="inst-table">
                        <thead>
                          <tr>
                            <th>Escola</th>
                            <th>Telefone</th>
                            <th>Província</th>
                            <th>Expiração</th>
                            <th>Nível</th>
                            <th>SMS</th>
                            <th className="text-end">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {visibleInstitutes.map((institute) => (
                            <tr key={institute.id}>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <div className="inst-logo">
                                    <img
                                      src={getLogo(institute)}
                                      alt={(institute && institute.name) || "Logo"}
                                      onError={(e) => {
                                        e.currentTarget.src =
                                          "https://shop.raceya.fit/wp-content/uploads/2020/11/logo-placeholder.jpg";
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <div style={{ fontWeight: 950 }}>{safeValue(institute.name, "Sem nome")}</div>
                                    <div className="small-muted">Código: {safeValue(institute.code, "—")}</div>
                                  </div>
                                </div>
                              </td>

                              <td>{safeValue(institute.phone)}</td>
                              <td>{safeValue(institute.state)}</td>

                              <td>
                                {institute.licence ? (
                                  <span className={getExpiryBadgeClass(institute.licence.remaining_days || 0)}>
                                    {(institute.licence.remaining_days || 0) + " dias"}
                                  </span>
                                ) : (
                                  <span className="small-muted">Sem licença</span>
                                )}
                              </td>

                              <td>
                                <select
                                  value={institute.role}
                                  onChange={(e) => handleRoleChange(institute.code, e.target.value)}
                                  className={getRoleClassName(institute.role)}
                                >
                                  <option value="normal">Normal</option>
                                  <option value="ensinobasico">Ensino Básico</option>
                                  <option value="ensinomedio">Ensino Médio</option>
                                </select>
                              </td>

                              <td>{(institute.totalsms ?? 0) + " sms"}</td>

                              <td className="text-end">
                                <div className="table-actions">
                                  <Tooltip title="Ver detalhes" arrow>
                                    <button
                                      className="action-icon"
                                      type="button"
                                      onClick={() => openDetails(institute)}
                                    >
                                      <FiEye />
                                    </button>
                                  </Tooltip>

                                  <Tooltip title="Pagamento SMS" arrow>
                                    <span>
                                      <RegisterSmsPaymentModal
                                        code={institute.code}
                                        toggle_btn={
                                          <button className="action-icon" type="button">
                                            <PaidIcon style={{ fontSize: 18 }} />
                                          </button>
                                        }
                                      />
                                    </span>
                                  </Tooltip>

                                  <Tooltip title="Pagamento licença" arrow>
                                    <span>
                                      <RegisterAndUpdateLicenceModal
                                        code={institute.code}
                                        toggle_btn={
                                          <button className="action-icon" type="button">
                                            <PaidIcon style={{ fontSize: 18 }} />
                                          </button>
                                        }
                                      />
                                    </span>
                                  </Tooltip>

                                  <Tooltip title="Remover instituição" arrow>
                                    <button
                                      className="action-icon"
                                      type="button"
                                      onClick={() => {
                                        setSelectedInstitute(institute.id);
                                        setShowDeleteModal(true);
                                      }}
                                    >
                                      <FiTrash2 />
                                    </button>
                                  </Tooltip>
                                </div>
                              </td>
                            </tr>
                          ))}

                          {visibleInstitutes.length === 0 ? (
                            <tr>
                              <td colSpan={7}>
                                <span className="small-muted">
                                  Nenhuma instituição encontrada para este filtro.
                                </span>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>

                    {/* MOBILE LIST */}
                    <div className="inst-mobile-list">
                      {visibleInstitutes.map((institute) => (
                        <div className="minst-card" key={institute.id}>
                          <div className="minst-row">
                            <div className="d-flex align-items-center gap-2">
                              <div className="inst-logo">
                                <img src={getLogo(institute)} alt={institute.name} />
                              </div>
                              <div>
                                <div style={{ fontWeight: 950 }}>{safeValue(institute.name, "Sem nome")}</div>
                                <div className="small-muted">{safeValue(institute.email)}</div>
                              </div>
                            </div>

                            <div className="text-end">
                              {institute.licence ? (
                                <span className={getExpiryBadgeClass(institute.licence.remaining_days || 0)}>
                                  {(institute.licence.remaining_days || 0) + " dias"}
                                </span>
                              ) : (
                                <span className="small-muted">Sem licença</span>
                              )}
                            </div>
                          </div>

                          <div className="minst-line" />

                          <div className="minst-row mb-2">
                            <span className="minst-pill">
                              <FiMapPin /> {safeValue(institute.state)}
                            </span>
                            <span className="minst-pill">
                              <FiLink /> {safeValue(institute.code)}
                            </span>
                          </div>

                          <div className="minst-row mb-2">
                            <span className="minst-pill">
                              <FiMessageSquare /> {(institute.totalsms ?? 0) + " sms"}
                            </span>
                            <select
                              value={institute.role}
                              onChange={(e) => handleRoleChange(institute.code, e.target.value)}
                              className={getRoleClassName(institute.role)}
                            >
                              <option value="normal">Normal</option>
                              <option value="ensinobasico">Ensino Básico</option>
                              <option value="ensinomedio">Ensino Médio</option>
                            </select>
                          </div>

                          <div className="minst-row">
                            <div className="d-flex flex-wrap gap-2">
                              <button className="btn-soft" type="button" onClick={() => openDetails(institute)}>
                                <FiEye /> Detalhes
                              </button>

                              <RegisterSmsPaymentModal
                                code={institute.code}
                                toggle_btn={
                                  <button className="btn-soft" type="button">
                                    <PaidIcon style={{ fontSize: 16 }} /> SMS
                                  </button>
                                }
                              />

                              <RegisterAndUpdateLicenceModal
                                code={institute.code}
                                toggle_btn={
                                  <button className="btn-soft" type="button">
                                    <PaidIcon style={{ fontSize: 16 }} /> Licença
                                  </button>
                                }
                              />
                            </div>

                            <button
                              className="btn-soft"
                              type="button"
                              style={{ borderColor: "rgba(239,68,68,.35)", color: theme === "dark" ? "#fecaca" : "#b91c1c" }}
                              onClick={() => {
                                setSelectedInstitute(institute.id);
                                setShowDeleteModal(true);
                              }}
                            >
                              <FiTrash2 /> Remover
                            </button>
                          </div>
                        </div>
                      ))}

                      {visibleInstitutes.length === 0 ? (
                        <span className="small-muted">Nenhuma instituição encontrada para este filtro.</span>
                      ) : null}
                    </div>

                    {/* PAGINATION */}
                    <div className="inst-footer">
                      <div className="small-muted">
                        Mostrando{" "}
                        {visibleInstitutes.length > 0 ? page * rowsPerPage + 1 : 0}–{page * rowsPerPage + visibleInstitutes.length} de{" "}
                        {filteredInstitutes.length} registos
                      </div>

                      <nav>
                        <ul className="pagination pagination-sm mb-0">
                          <li className={`page-item ${page === 0 ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => setPage((p) => Math.max(0, p - 1))}>
                              «
                            </button>
                          </li>
                          {renderPageNumbers()}
                          <li className={`page-item ${page + 1 === pageCount ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => setPage((p) => Math.min(pageCount - 1, p + 1))}>
                              »
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                ) : null}

                {/* ===== TAB: GALERIA ===== */}
                {clientsTab === "institutes_grid" ? (
                  <>
                    <div className="grid-wrap">
                      {visibleInstitutes.map((inst) => {
                        const code = inst.code;
                        const imgs = gridImagesCache[code] || [];
                        const hasImgs = imgs.length > 0;

                        const carouselId = `instCarousel_${String(code || inst.id).replace(/[^a-zA-Z0-9_]/g, "_")}`;

                        return (
                          <div className="gcard" key={inst.id}>
                            <div className="gcarousel">
                              <div
                                id={carouselId}
                                className="carousel slide"
                                data-bs-ride={hasImgs ? "carousel" : undefined}
                                data-bs-interval={hasImgs ? "4500" : undefined}
                              >
                                <div className="carousel-inner">
                                  {hasImgs ? (
                                    imgs.slice(0, 6).map((img, idx) => (
                                      <div
                                        key={img.id || idx}
                                        className={"carousel-item" + (idx === 0 ? " active" : "")}
                                        onClick={() => openLightbox(img.url)}
                                        role="button"
                                        title="Clique para ampliar"
                                      >
                                        <img src={img.url} alt={inst.name || "Imagem"} />
                                      </div>
                                    ))
                                  ) : (
                                    <div className="carousel-item active">
                                      <img
                                        src={"https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png"}
                                        alt="placeholder"
                                      />
                                    </div>
                                  )}
                                </div>

                                {hasImgs && imgs.length > 1 ? (
                                  <>
                                    <div className="carousel-indicators">
                                      {imgs.slice(0, 6).map((_, i) => (
                                        <button
                                          key={i}
                                          type="button"
                                          data-bs-target={`#${carouselId}`}
                                          data-bs-slide-to={i}
                                          className={i === 0 ? "active" : ""}
                                          aria-current={i === 0 ? "true" : "false"}
                                          aria-label={`Slide ${i + 1}`}
                                        />
                                      ))}
                                    </div>

                                    <button className="carousel-control-prev" type="button" data-bs-target={`#${carouselId}`} data-bs-slide="prev">
                                      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                      <span className="visually-hidden">Anterior</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target={`#${carouselId}`} data-bs-slide="next">
                                      <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                      <span className="visually-hidden">Seguinte</span>
                                    </button>
                                  </>
                                ) : null}
                              </div>
                            </div>

                            <div className="gbody">
                              <div className="gtitle">
                                <span>{safeValue(inst.name, "Sem nome")}</span>
                                <span className="minst-pill">
                                  <FiImage /> {hasImgs ? imgs.length : 0}
                                </span>
                              </div>

                              <div className="gdesc">{instituteCardDesc(inst)}</div>

                              <div className="gmeta">
                                <span>
                                  <FiMapPin /> {safeValue(inst.state)}
                                </span>
                                <span>
                                  <FiLink /> {safeValue(inst.code)}
                                </span>
                              </div>

                              <div className="gactions">
                                <div className="gaction-left">
                                  <Tooltip title="Ver detalhes" arrow>
                                    <button className="giconbtn" type="button" onClick={() => openDetails(inst)}>
                                      <FiEye />
                                    </button>
                                  </Tooltip>

                                  <Tooltip title="Pagar SMS" arrow>
                                    <span>
                                      <RegisterSmsPaymentModal
                                        code={inst.code}
                                        toggle_btn={
                                          <button className="giconbtn" type="button">
                                            <PaidIcon style={{ fontSize: 18 }} />
                                          </button>
                                        }
                                      />
                                    </span>
                                  </Tooltip>

                                  <Tooltip title="Pagar licença" arrow>
                                    <span>
                                      <RegisterAndUpdateLicenceModal
                                        code={inst.code}
                                        toggle_btn={
                                          <button className="giconbtn" type="button">
                                            <PaidIcon style={{ fontSize: 18 }} />
                                          </button>
                                        }
                                      />
                                    </span>
                                  </Tooltip>
                                </div>

                                <Tooltip title="Remover" arrow>
                                  <button
                                    className="giconbtn"
                                    type="button"
                                    onClick={() => {
                                      setSelectedInstitute(inst.id);
                                      setShowDeleteModal(true);
                                    }}
                                  >
                                    <FiTrash2 />
                                  </button>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {/* PAGINATION */}
                    <div className="inst-footer">
                      <div className="small-muted">
                        Mostrando{" "}
                        {visibleInstitutes.length > 0 ? page * rowsPerPage + 1 : 0}–{page * rowsPerPage + visibleInstitutes.length} de{" "}
                        {filteredInstitutes.length} registos
                      </div>

                      <nav>
                        <ul className="pagination pagination-sm mb-0">
                          <li className={`page-item ${page === 0 ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => setPage((p) => Math.max(0, p - 1))}>
                              «
                            </button>
                          </li>
                          {renderPageNumbers()}
                          <li className={`page-item ${page + 1 === pageCount ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => setPage((p) => Math.min(pageCount - 1, p + 1))}>
                              »
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </>
                ) : null}

                {/* ===== TAB: ANALYTICS ===== */}
                {clientsTab === "institutes_analytics" ? (
                  <div style={{ marginTop: 10 }}>
                    <InstitutesAnalytics institutes={filteredInstitutes} />
                  </div>
                ) : null}
              </div>
            </section>

          </main>
        </div>

        {/* DELETE INSTITUTE MODAL */}
        <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "var(--card)",
              borderRadius: 3,
              boxShadow: 24,
              p: 3,
              minWidth: 320,
              border: "1px solid var(--border)",
              color: "var(--text)",
            }}
          >
            <h5 className="mb-2" style={{ fontWeight: 900 }}>
              Confirmar remoção
            </h5>
            <p className="mb-3" style={{ color: "var(--muted)", fontWeight: 650 }}>
              Tem certeza que deseja remover esta instituição? Esta ação não pode ser desfeita.
            </p>
            <div className="d-flex justify-content-end gap-2">
              <MButton variant="outlined" onClick={() => setShowDeleteModal(false)}>
                Cancelar
              </MButton>
              <MButton variant="contained" color="error" onClick={handleDeleteInstitute}>
                Remover
              </MButton>
            </div>
          </Box>
        </Modal>

        {/* OFFCANVAS BACKDROP + PANEL (custom) */}
        <div className={"oc-backdrop" + (detailsOpen ? " show" : "")} onClick={closeDetails} />

        <div className={"oc-panel" + (detailsOpen ? " show" : "")} aria-hidden={!detailsOpen}>
          {/* HERO SLIDER */}
          <div className="oc-hero">
            {detailsLoading ? (
              <div className="oc-hero-empty">
                <CircularProgress size={26} />
                <p>A carregar imagens e detalhes…</p>
              </div>
            ) : hasHero ? (
              <>
                {heroImages.map((img, idx) => (
                  <div
                    key={img.id || idx}
                    className={"oc-hero-slide" + (idx === sliderIndex ? " active" : "")}
                    onClick={() => openLightbox(img.url)}
                    role="button"
                    title="Clique para ampliar"
                  >
                    <img src={img.url} alt={detailsInstitute?.name || "Imagem"} />
                    <div className="oc-hero-overlay" />
                  </div>
                ))}

                <div className="oc-hero-topbar">
                  <span
                    className="oc-hero-badge"
                    title={detailsInstitute?.name || ""}
                  >
                    {clampName(detailsInstitute?.name || "Instituição", 40)}
                  </span>

                  <div className="oc-hero-nav">
                    <button className="oc-hero-btn" type="button" onClick={goPrev} title="Anterior">
                      <FiChevronLeft />
                    </button>
                    <button className="oc-hero-btn" type="button" onClick={goNext} title="Seguinte">
                      <FiChevronRight />
                    </button>
                    <button className="oc-hero-btn" type="button" onClick={closeDetails} title="Fechar">
                      <FiX />
                    </button>
                  </div>
                </div>

                <div className="oc-hero-dots">
                  {heroImages.map((_, i) => (
                    <span
                      key={i}
                      className={"oc-dot" + (i === sliderIndex ? " active" : "")}
                      onClick={() => setSliderIndex(i)}
                      title={`Imagem ${i + 1}`}
                    />
                  ))}
                </div>
              </>
            ) : (
              <div className="oc-hero-empty">
                <FiImage style={{ fontSize: 26, opacity: 0.85 }} />
                <h6>Sem imagens extras</h6>
                <p>
                  Adicione imagens no separador <b>Imagens</b> para aparecerem aqui.
                </p>
                <button className="btn-soft" type="button" onClick={closeDetails}>
                  <FiX /> Fechar
                </button>
              </div>
            )}
          </div>

          {/* BODY */}
          <div className="oc-body">
            <div className="oc-headline">
              <div>
                <p className="oc-title">{safeValue(detailsInstitute?.name)}</p>
                <div className="oc-sub">
                  <span className="oc-chip">
                    <FiMapPin /> {safeValue(detailsInstitute?.state)}
                  </span>
                  <span className="oc-chip">
                    <FiLink /> Código: {safeValue(detailsInstitute?.code)}
                  </span>
                  <span className="oc-chip">
                    <FiImage /> {heroImages.length} imagem(ns)
                  </span>
                </div>
              </div>

              <Tooltip title="Fechar" arrow>
                <button className="btn-icon" type="button" onClick={closeDetails}>
                  <FiX />
                </button>
              </Tooltip>
            </div>

            {/* TABS */}
            <div className="oc-tabs">
              <button
                className={"oc-tab" + (detailsTab === "fields" ? " active" : "")}
                onClick={() => setDetailsTab("fields")}
                type="button"
              >
                Campos / Notas
              </button>
              <button
                className={"oc-tab" + (detailsTab === "map" ? " active" : "")}
                onClick={() => setDetailsTab("map")}
                type="button"
              >
                Mapa
              </button>
              <button
                className={"oc-tab" + (detailsTab === "images" ? " active" : "")}
                onClick={() => setDetailsTab("images")}
                type="button"
              >
                Imagens
              </button>
            </div>

            {/* TAB: FIELDS */}
            {detailsTab === "fields" ? (
              <div className="oc-block">
                <div className="oc-grid">
                  <div>
                    <div className="oc-label">Nome do campo</div>
                    <input
                      className="oc-input"
                      value={newFieldKey}
                      onChange={(e) => setNewFieldKey(e.target.value)}
                      placeholder="Ex.: Observações, Segmento, Prioridade…"
                    />
                  </div>
                  <div>
                    <div className="oc-label">Valor</div>
                    <input
                      className="oc-input"
                      value={newFieldValue}
                      onChange={(e) => setNewFieldValue(e.target.value)}
                      placeholder="Texto / informação"
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                  <button className="btn-soft" type="button" onClick={addField}>
                    <FiPlus /> Adicionar
                  </button>
                </div>

                <div className="mt-3" style={{ maxHeight: 280, overflow: "auto" }}>
                  {(detailsData.fields || []).length ? (
                    <table className="table table-sm mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: "35%" }}>Campo</th>
                          <th>Valor</th>
                          <th className="text-end" style={{ width: 120 }}>
                            Ações
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {detailsData.fields.map((f) => (
                          <tr key={f.id}>
                            <td style={{ fontWeight: 950 }}>{f.key}</td>
                            <td>{f.value || "—"}</td>
                            <td className="text-end">
                              <Tooltip title="Remover campo" arrow>
                                <button className="btn-icon" type="button" onClick={() => deleteField(f.id)}>
                                  <FiTrash2 />
                                </button>
                              </Tooltip>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="small-muted">Sem campos extra ainda.</div>
                  )}
                </div>
              </div>
            ) : null}

            {/* TAB: MAP */}
            {detailsTab === "map" ? (
              <div className="oc-block">
                <div className="oc-label">Iframe do Google Maps</div>
                <textarea
                  className="oc-input"
                  style={{ minHeight: 120 }}
                  value={mapIframe}
                  onChange={(e) => setMapIframe(e.target.value)}
                  placeholder="<iframe ...></iframe>"
                />

                <div className="d-flex justify-content-end mt-3 gap-2">
                  <button className="btn-soft" type="button" onClick={saveMap}>
                    <FiEdit2 /> Guardar
                  </button>
                </div>

                <div className="mt-3">
                  {(detailsData.map_iframe || mapIframe || "").trim() ? (
                    <div
                      style={{
                        borderRadius: 18,
                        overflow: "hidden",
                        border: "1px solid var(--border)",
                        background: "rgba(148,163,184,0.06)",
                      }}
                      dangerouslySetInnerHTML={{ __html: detailsData.map_iframe || mapIframe }}
                    />
                  ) : (
                    <div className="small-muted">Sem iframe definido.</div>
                  )}
                </div>
              </div>
            ) : null}

            {/* TAB: IMAGES */}
            {detailsTab === "images" ? (
              <div className="oc-block">
                <div className="oc-label">Adicionar imagens extras</div>

                {/* Local preview list before upload */}
                {uploadImages.length ? (
                  <div className="small-muted mb-2">
                    Pré-visualização: {uploadImages.length} imagem(ns) selecionada(s)
                  </div>
                ) : null}

                <input
                  className="oc-input"
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => setUploadImages(Array.from(e.target.files || []))}
                />

                <div className="d-flex justify-content-end mt-3">
                  <button className="btn-soft" type="button" onClick={uploadExtraImages}>
                    <FiUpload /> Enviar
                  </button>
                </div>

                {/* Preview selected images (before upload) */}
                {uploadImages.length ? (
                  <div className="img-grid mt-3">
                    {uploadImages.slice(0, 6).map((f, idx) => {
                      const url = URL.createObjectURL(f);
                      return (
                        <div key={idx} className="img-item">
                          <img
                            src={url}
                            alt="preview"
                            onLoad={() => URL.revokeObjectURL(url)}
                            style={{ cursor: "default" }}
                          />
                          <div className="img-actions">
                            <span className="small-muted">{safeValue(f.name)}</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}

                <div className="mt-3 img-grid">
                  {(detailsData.images || []).map((img) => (
                    <div key={img.id} className="img-item">
                      <img src={img.url} alt="extra" onClick={() => openLightbox(img.url)} role="button" />
                      <div className="img-actions">
                        <Tooltip title="Ver imagem" arrow>
                          <button className="btn-icon" type="button" onClick={() => openLightbox(img.url)}>
                            <FiEye />
                          </button>
                        </Tooltip>
                        <Tooltip title="Remover imagem" arrow>
                          <button className="btn-icon" type="button" onClick={() => deleteImage(img.id)}>
                            <FiTrash2 />
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  ))}
                </div>

                {(detailsData.images || []).length === 0 ? (
                  <div className="small-muted mt-2">Sem imagens ainda.</div>
                ) : null}
              </div>
            ) : null}
          </div>

          {/* LIGHTBOX */}
          <Modal open={lightboxOpen} onClose={() => setLightboxOpen(false)}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "rgba(2,6,23,0.92)",
                borderRadius: 3,
                boxShadow: 24,
                p: 1,
                width: "min(1100px, 96vw)",
              }}
            >
              <div className="d-flex justify-content-end">
                <button className="btn-icon" type="button" onClick={() => setLightboxOpen(false)} title="Fechar">
                  <FiX />
                </button>
              </div>
              <img
                src={lightboxUrl}
                alt="preview"
                style={{ width: "100%", maxHeight: "78vh", objectFit: "contain", borderRadius: 12 }}
              />
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default MainDashboard;